import { ReactNode } from "react"

import {
  Box,
  Divider,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react"

type CustomModalPropType = {
  children: ReactNode
  errorMessage?: string
  errorModel?: boolean
  footer?: ReactNode
  isOpen: boolean
  maxH?: string
  maxW?: string
  onClose: () => void
  size?: string
  title?: string | ReactNode
  isCentered?: boolean
  stickyHeader?: boolean
}
const CustomModal = ({
  title,
  children,
  footer,
  isOpen,
  onClose,
  maxH = "600px",
  errorModel = false,
  errorMessage = "",
  size,
  maxW,
  isCentered = false,
  stickyHeader = false,
}: CustomModalPropType) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={size}
      isCentered={isCentered}
    >
      <ModalOverlay />
      <ModalContent maxH={maxH} maxW={maxW} overflow='auto'>
        <ModalHeader
          display='flex'
          alignItems='center'
          pt={4}
          {...(stickyHeader && {
            px: 6,
            pb: 3,
            flexShrink: 0,
            position: "sticky",
            top: 0,
            zIndex: 1,
            bg: "white",
          })}
        >
          <>
            {errorModel && <Box h={"20px"} />}
            {title ? (
              <Text size='lg3' fontWeight={700} fontSize='20px'>
                {title}
              </Text>
            ) : (
              <Box h={"20px"} />
            )}
          </>
          <ModalCloseButton mt='5px' />
        </ModalHeader>
        <Divider />
        <ModalBody width={"100%"} px={6} pb={6} pt={"24px"}>
          {errorModel ? <Text>{errorMessage}</Text> : children}
        </ModalBody>
        {footer ? (
          <>
            <Divider />
            <ModalFooter
              justifyContent='flex-end'
              px={6}
              py={4}
              flexShrink={0}
              position='sticky'
              bottom={0}
              zIndex={1}
              bg='white'
            >
              {footer}
            </ModalFooter>
          </>
        ) : null}
      </ModalContent>
    </Modal>
  )
}

export default CustomModal
